/* Preserve Horizon's variant and Globo's preorder behavior; enhance presentation only. */
class ToileBundleContents extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.controller = new AbortController();
    this.details = this.closest('.toile-product-details');
    if (!this.details) return;
    this.dataset.enhanced = '';
    const { signal } = this.controller;
    this.addEventListener('click', (event) => this.handleClick(event), { signal });
    this.details.addEventListener('variant:update', (event) => {
      if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
      if (event.detail?.resource?.id) this.dataset.selectedVariant = String(event.detail.resource.id);
      if (this.dataset.editionPosition) this.syncEditionOption();
      else if (event.detail?.resource?.id) this.showEdition(String(event.detail.resource.id));
    }, { signal });
    this.observer = new MutationObserver(() => this.enhanceShipping());
    this.observer.observe(this.details, { childList: true, subtree: true, characterData: true });
    this.enhanceShipping();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }

  handleClick(event) {
    const optionButton = event.target.closest('[data-toile-option-value-id]');
    if (optionButton && this.contains(optionButton)) {
      const picker = this.details.querySelector('variant-picker');
      const input = picker?.querySelector(`input[data-option-value-id="${optionButton.dataset.toileOptionValueId}"]`);
      if (input?.checked) this.syncEditionOption();
      else input?.click();
      return;
    }
    const editionButton = event.target.closest('[data-toile-variant]');
    if (editionButton && this.contains(editionButton)) {
      const id = editionButton.dataset.toileVariant;
      const picker = this.details.querySelector('variant-picker');
      const input = picker?.querySelector(`input[data-variant-id="${id}"]`);
      if (input?.checked) this.showEdition(id);
      else input?.click();
      return;
    }
    const expandButton = event.target.closest('.toile-show-contents');
    if (expandButton && this.contains(expandButton)) {
      const panel = expandButton.closest('.toile-content-panel');
      const expanded = panel.dataset.expanded !== 'true';
      panel.dataset.expanded = String(expanded);
      expandButton.setAttribute('aria-expanded', String(expanded));
      expandButton.textContent = expanded ? 'Show less −' : 'View full contents +';
    }
  }

  showEdition(id) {
    if (!this.querySelector(`[data-toile-panel="${id}"]`)) return;
    this.dataset.selectedVariant = id;
    this.querySelectorAll('[data-toile-variant]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.toileVariant === id));
    });
    this.querySelectorAll('[data-toile-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.toilePanel !== id;
    });
  }

  syncEditionOption() {
    // Use the native edition option, preserving the two Mystery color choices.
    const index = Number(this.dataset.editionPosition) - 1;
    const value = this.details.querySelector(`variant-picker input[data-fieldset-index="${index}"]:checked`)?.value;
    if (!value) return;
    this.querySelectorAll('[data-toile-edition]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.toileEdition === value));
    });
    this.querySelectorAll('[data-toile-edition-panel]').forEach(panel => {
      panel.hidden = panel.dataset.toileEditionPanel !== value;
    });
  }

  enhanceShipping() {
    // Horizon refreshes this text after a variant change; keep Globo's loaded
    // preorder button clearly labelled without altering its handlers or inputs.
    this.details.querySelectorAll('.gPreorderBtnLoaded .add-to-cart-text__content').forEach((label) => {
      if (label.textContent.trim() === 'Add to cart') label.textContent = 'Pre-Order';
    });
    this.details.querySelectorAll('.gPreorderBottomMessage').forEach((message) => {
      if (message.querySelector('.toile-shipping-heading')) return;
      const original = message.textContent.trim();
      const match = original.match(/Expected to ship in\s+([^.!]+)[.!]?/i);
      // Only replace the known handcrafted-bundle message; preserve unrelated app notices.
      if (!match || !/handcrafted bundle/i.test(original)) return;
      const heading = document.createElement('span');
      heading.className = 'toile-shipping-heading';
      heading.append(document.createTextNode('Pre-order · Expected to ship in '));
      const month = document.createElement('strong');
      month.textContent = match[1].trim().toUpperCase();
      heading.append(month);
      const detail = document.createElement('span');
      detail.className = 'toile-shipping-detail';
      detail.textContent = 'Each bundle is carefully assembled by hand.';
      message.classList.add('toile-shipping');
      message.replaceChildren(heading, detail);
    });
  }
}

if (!customElements.get('toile-bundle-contents')) {
  customElements.define('toile-bundle-contents', ToileBundleContents);
}
